import React from "react";
import ItemWrapper from "./ItemWrapper";
import { CryptoItems } from "../Trade/CryptoItems";
import useFetch from "../../hooks/useFetch"

const Trade = (props) => {
  const {response:rates} = useFetch()
  return (
      <div className="row">
        {CryptoItems.map((item) => (
          <div key={item.id} className="col-md-4 d-flex justify-content-center">
          <ItemWrapper
            id={item.id}
            src={item.src}
            name={item.name}
            brate={rates.length >0 ? rates.filter(el=>el.Crypto === item.short)[0].Buy:""}
            srate={rates.length >0 ? rates.filter(el=>el.Crypto === item.short)[0].Sell:""}
            img={item.img}
            available={item.srate === "Coming soon" ? "true" : "false"}
          />
          </div>
        ))}
      </div>
  );
};

export default Trade;
